import { createFileRoute } from '@tanstack/react-router';
import { zodSearchValidator } from '@tanstack/router-zod-adapter';

import { keyPortsSearchSchema } from '../../types/keyPortsSearchSchema';
import { KeyPortOverviewPage } from '../keyport/KeyPortOverviewPage';

export const Route = createFileRoute('/_app/key-ports')({
    component: KeyPortOverviewPage,
    validateSearch: zodSearchValidator(keyPortsSearchSchema),
});
